import { Button, Divider, Grid2, Tab, Tabs } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import DashboardLayout from "layouts/DashboardLayout";
import { useState } from "react";
import toast from "react-hot-toast";
import { TbArrowBackUp } from "react-icons/tb";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import { QueryKeys } from "utils/queryKey";
import CompanyCard from "./CompanyCard";
import CorporateActions from "./CorporateActions";
import FundamentalDetails from "./FundamentalDetails";
import HistoricalPrices from "./HistoricalPrices";
import PricesPage from "./PricesPage";

const CompanyUpdate = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const [companyTabs, setCompanyTabs] = useState(0);

  const {
    data: companyDetails,
    isFetching: companyFetching,
    refetch,
  } = useQuery({
    queryKey: [QueryKeys.COMPANY_LIST, id],
    queryFn: async () => axiosInstance.get(`/admin-instrument/${id}/details/`),
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  return (
    <DashboardLayout
      title="Company Details"
      toolbar={
        <Button size="extraSmall" onClick={() => navigate(-1)}>
          Back &nbsp; <TbArrowBackUp />
        </Button>
      }
    >
      <Grid2 container>
        <Grid2 size={12} mb={1}>
          <CompanyCard companyDetails={companyDetails?.data} />
        </Grid2>
        <Grid2 size={12} mb={4}>
          <Tabs
            variant="fullWidth"
            onChange={(e, val) => {
              setCompanyTabs(val);
            }}
            value={companyTabs}
          >
            <Tab disableRipple label="Fundamental Details" />
            <Tab disableRipple label="NSE, BSE And ISIN" />
            <Tab disableRipple label="Historical Prices" />
            <Tab disableRipple label="Corporate Actions" />
          </Tabs>
          <Divider />
        </Grid2>

        <Grid2 size={12}>
          {!companyFetching && companyTabs === 0 && (
            <FundamentalDetails
              companyDetails={companyDetails?.data?.data}
              refetch={refetch}
            />
          )}
        </Grid2>
        <Grid2 size={12}>{companyTabs === 1 && <PricesPage />}</Grid2>
        <Grid2 size={12}>{companyTabs === 2 && <HistoricalPrices />}</Grid2>
        <Grid2 size={12}>
          {companyTabs === 3 && (
            <CorporateActions companyDetails={companyDetails?.data?.data} />
          )}
        </Grid2>
      </Grid2>
    </DashboardLayout>
  );
};

export default CompanyUpdate;
